








import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import Company from "../../models/company/Company";
import {Icon} from "@/helpers/icons";
import {enumTextFromValue} from "@/helpers/functions_asi";
import {CompanyState} from "@/helpers/constants";
import AsiCardDetail from "../common/AsiCardDetail.vue";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";

@Component({
	components: {AsiCardDetailEntry, AsiCardDetail}
})
export default class CompanyCardSettings extends Vue {

	@Prop({type: Object, default: null})
	public company!: Company | null;

	private icons = Icon;

	private get stateLabel(): string | null {
		return enumTextFromValue(CompanyState, this.company?.state ?? null, true);
	}

}
